import {entries} from '@benchling/js-utils';
import {Base64} from 'js-base64';

import {ChemicalFileFormat, CHEMICAL_FILE_FORMAT_TO_EXTENSION} from 'chemistry/ChemistryConstants';
import {splitExtension} from 'util/FileUtil';

export const IS_CHEMICAL_FILE_FORMAT_BINARY: Record<ChemicalFileFormat, boolean> = {
  [ChemicalFileFormat.CDX]: true,
  [ChemicalFileFormat.MOL]: false,
  [ChemicalFileFormat.SMILES]: false,
  [ChemicalFileFormat.INCHI]: false,
  [ChemicalFileFormat.RDF]: false,
  [ChemicalFileFormat.MRV]: false,
  [ChemicalFileFormat.SDF]: false,
};

export async function getChemicalFileContent(
  fileFormat: ChemicalFileFormat,
  content: Blob | Response
): Promise<string> {
  if (IS_CHEMICAL_FILE_FORMAT_BINARY[fileFormat]) {
    const buffer = await content.arrayBuffer();
    // Convert file content bytes to a base64 string for binary file formats.
    return Base64.fromUint8Array(new Uint8Array(buffer));
  } else {
    return await content.text();
  }
}

export function guessChemicalFileFormat(file: File): ChemicalFileFormat {
  const {extension} = splitExtension(file.name);
  for (const [format, knownExtension] of entries(CHEMICAL_FILE_FORMAT_TO_EXTENSION)) {
    if (extension.toLowerCase() === `.${knownExtension}`) {
      return format as ChemicalFileFormat;
    }
  }
  throw new Error(`Unrecognized file extension: ${extension}`);
}
